<template>
  <el-dialog
    id="SampleItem"
    :title="num === 1 ? '单人标本录入' : num + '人混采标本录入'"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div>
      <el-row>
        <el-col :span="24">
          <span style="color: red">*</span>检验项目
        </el-col>
        <el-col :span="24">
          <el-select
            style="width: 100%;margin-top: 15px;"
            v-model="dataForm.itemInfo"
            filterable
            remote
            reserve-keyword
            placeholder="请选择"
            :remote-method="remoteMethod"
            :loading="loading"
            value-key="id"
            clearable
          @change="handleChange">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.label"
              :value="item.obj">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row style="text-align: center;">
        <el-col :span="24">
          <el-button style="width: 200px;height: 45px;" type="primary" @click="handleConfirm">开始录入</el-button>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'sample-item',
    data() {
      return {
        visible: false,
        dataForm: {
          itemInfo: ''
        },
        options: [],
        loading: false,
        num: 0
      }
    },
    methods: {
      init (num) {
        this.num = num
        this.visible = true
        this.remoteMethod('', 1)
      },

      remoteMethod (query, flag) {
        this.loading = true
        axios.get("/jys/hospSample/services", {
          params: {
            name: query
          }
        }).then((res) => {
          this.loading = false
          if (res.data.code === 0) {
            this.options = res.data.list.map(item => {
              return { id: `${item.id}`, label: `${item.itemName}`, obj: {id: item.id, itemName: item.itemName} }
            })

            if (flag && this.options.length === 1) {
              this.$set(this.dataForm, 'itemInfo', this.options[0].obj)
            }
          }
        })
      },

      handleConfirm () {
        if (this.dataForm.itemInfo.id) {
          this.$emit("refreshMix", this.num, this.dataForm.itemInfo.id)
        } else {
          this.$message.warning('检验项目不能为空')
        }
      },

      handleChange (item) {
        console.log(item)
      }
    }
  }
</script>

<style scoped>
  * {
    font-size: 15px;
  }
  #SampleItem >>> .el-dialog__header{
    text-align: center;
  }
  #SampleItem >>> .el-dialog__title{
    color: #000000;
    font-size: 17px;
    font-weight: bold;
  }
  #SampleItem >>> .el-dialog__body{
    padding: 20px 5%;
    color: #000000;
  }
  #SampleItem >>> .el-input--small .el-input__inner {
    height: 45px;
    line-height: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sample-item.vue